module.exports = __webpack_public_path__ + "static/img/R1.0635b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/R1.png
// module id = T6Fs
// module chunks = 0